import * as React from 'react';
import { tableLoading } from "src/modules/Alert/ControlCenter/utils/placeholders";
import { timestampToDateTimeString } from "src/share/utils/utils";
import { IETLLog, IRekLog } from "src/share/types/serviceStatus";
import environmentHelper from "src/share/utils/environmentHelper";
import usePhotoViewer from 'src/share/components/PhotoViewer/usePhotoViewer';

export const etlColumns = (isLoading: boolean) => [
  { name: 'Date', width: '200px', sortable: true, ...tableLoading('startDate', isLoading, 100) },
  { name: 'Status', width: '180px', ...tableLoading('status', isLoading, 80) },
  { name: 'Execution type', ...tableLoading('executionType', isLoading, 60) },
  { name: 'Number of cases', sortable: true, ...tableLoading('numberOfCases', isLoading, 25) }
];

const etlTableFormat = (logs: IETLLog[]) => logs.map((log: any) => ({
  ...log,
  status: log.numberOfCases ? "PROCESSED" : "PROCESSING",
  startDate: timestampToDateTimeString(log.startDate),
  executionType: log.executionType === "AGENCY" ? log.executionConfig.type : log.executionType
}));

export const rekognitionColumns = (isLoading: boolean) => [
  { name: 'Date', width: '200px', sortable: true, ...tableLoading('date', isLoading, 100) },
  { name: 'Status', width: '180px', ...tableLoading('status', isLoading, 80) },
  { name: 'Image', width: 'auto', ...tableLoading('key', isLoading, 60) },
];

const rekRoot = environmentHelper.getRekognitionImageRoot();
const rekognitionTableFormat = (logs: IRekLog[]) => logs.map((log) => {
  const { handleZoomInImage } = usePhotoViewer();
  return {
    ...log,
    date: timestampToDateTimeString(log.date),
    key: <a className="image-log" onClick={() => handleZoomInImage({ source: `${rekRoot}/${log.key}`, boundingBoxes: [] })} >{log.key}</a>
  }
});

export const handleTableLogSettings = (mode: string, logs: IETLLog[] | IRekLog[], isLoading: boolean) => {
  const settings = {
    etl: {
      colums: etlColumns(isLoading),
      format: etlTableFormat(logs as IETLLog[])
    },
    rek: {
      colums: rekognitionColumns(isLoading),
      format: rekognitionTableFormat(logs as IRekLog[])
    }
  }
  return settings[mode];
};



// WEBPACK FOOTER //
// ./src/modules/UserSettings/ServicesStatus/utils/tableLogs.tsx